import React, { ChangeEvent } from "react";
import * as app from "../services/AppService";
import { RowItem } from "../models/Core/row-item";
import { InterfaceComponentsProps } from "../models/Core/componentsCore";

 

interface Props extends RowItem, Omit<InterfaceComponentsProps, "Class" | "Icon" | "isTable"> {
    onChange?: (res: boolean) => void,
    onBlur?: () => void,
    address?: string,
    containerClass?: string,
    model: string | boolean,
    name?: string
}
function RadioBox(props: Props) {
    function handler(event: ChangeEvent<HTMLInputElement>) {
        const { checked } = event.target;
        if (props.onChange && typeof props.onChange == "function")
            props.onChange(checked);
    }
    function blurHandler() {
        if (props.onBlur && typeof props.onBlur == "function")
            props.onBlur();
    }

    return (
        <>
            {app.translate(props.address) && <p className="text-primary-emphasis fw-semibold m-1">{app.translate(props.address)}</p>}

            <div className={props.containerClass}>
                <input
                    id={props.id ? props.id : "radio" + props.label}
                    key={"radio-key" + props.id ? props.id : props.label}
                    type="radio"
                    name={"radio-name" + props.id ? props.id : props.label}
                    disabled={props.disabled}
                    className="form-check-input ms-1"
                    onChange={handler}
                    value={props.model.toString()}
                    checked={app.getBoolean(props.model)}
                    onBlur={blurHandler}
                />
                <label htmlFor={"radio-name" + props.id ? props.id : props.label} className={"ms-2 " + props.labelClass}>
                    {app.translate(props.label)}
                </label>
            </div>
        </>
    );
}

RadioBox.defaultProps = {
    class: "fw-semibold text-primary-emphasis ",
    containerClass: "",
    name: "chk",
    label: "",
    disabled: false,
};

export default RadioBox;